import type { IconSvgObject } from './types';

const PeriscopeIcon: IconSvgObject = [
  ["path", { d: "M12 2C16.4183 2 20 5.61783 20 10.0807C20 12.6325 19 14 17 16.389L12 22L7 16.389C5 14 4 12.6325 4 10.0807C4 5.61783 7.58172 2 12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C11.838 6 11.6782 6.00963 11.5212 6.02836C11.8223 6.44123 12 6.94986 12 7.5C12 8.88071 10.8807 10 9.5 10C8.94986 10 8.44123 9.8223 8.02836 9.52118C8.00963 9.67817 8 9.83796 8 10C8 12.2091 9.79086 14 12 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PeriscopeIcon;
